import * as React from "react";

const d365ScriptContent = React.createContext({
  isReady: false,
});

function D365ScriptProvider(props) {
  const { children, leadSource, contactSource, vorneDomain } = props;
  const [isReady, setIsReady] = React.useState(false);
  const { Provider } = d365ScriptContent;

  React.useEffect(() => {
    const scriptVersion = "1.84.2007";
    const scriptUrl = `https://mktdplp102cdn.azureedge.net/public/latest/js/form-loader.js?v=${scriptVersion}`;
    const scriptEl = document.createElement("script");
    scriptEl.id = "d365-form-loader";
    scriptEl.src = scriptUrl;
    scriptEl.async = true;
    scriptEl.onload = () => {
      setIsReady(true);
    };
    document.body.append(scriptEl);

    return () => {
      window.MsCrmMkt = undefined;
      const iframe = document.querySelector('iframe[src*="dynamics.com"]');
      if (iframe) {
        iframe.remove();
      }
      scriptEl.remove();
    };
  }, []);

  return (
    <Provider value={{ isReady, leadSource, contactSource, vorneDomain }}>
      {children}
    </Provider>
  );
}

export { d365ScriptContent };
export default D365ScriptProvider;
